import React, { Component } from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import { assign, cloneDeep, filter, forEach, isEmpty, isEqual } from 'lodash';
import { Form, Row, Col } from 'react-bootstrap';
import { Bert } from 'meteor/themeteorchef:bert';
import turf from '@turf/turf';

import { FeatureLineString } from '../../../api/SchemaUtilities/GeoJSONSchema';
import * as videoOps from '../../../api/Videos/video-operations';

import handleErrorInClient from '../../../modules/handle-error-in-client';

import ConfirmationModal from '../../atoms/ConfirmationModal';
import TagInput from '../TagInput';
import VideoFields from '../VideoFields';

import MapContainerVideoEditor from '../../containers/MapContainerVideoEditor';
import Validation from '../../containers/Validation';
import {
  VIDEO_COORDINATE_DATA_TYPES,
  URL_REGEX,
  YOUTUBE_URL_REGEX,
  VIDEO_TYPES
} from '../../../api/Videos/Videos';

let createTrackFromKML;
let createTrackFromCSV;
let createTrackFromGoProCSV;

class VideoEditor extends Component {
  state = {
    areCoordinatesUndefined: videoOps.areCoordinatesUndefined(this.props.updatedVideo),
    buttonStates: {
      definePointActive: false,
      defineLineActive: false
    },
    clientModulesReady: false,
    controlPoints: videoOps.getControlPoints(this.props.updatedVideo),
    coordinatesDataType: videoOps.getCoordinatesDataType(this.props.updatedVideo),
    featureArray: this.props.featureArray,
    geometryFileName: videoOps.getGeometryFileName(this.props.updatedVideo),
    logFileName: videoOps.getLogFileName(this.props.updatedVideo),
    importFileName: '',
    isLoadingImporFile: false,
    latLng0: videoOps.getLatLng0(this.props.updatedVideo),
    mapLocation: this.props.mapLocation,
    showModal: false,
    tags: videoOps.getTags(this.props.updatedVideo),
    track: videoOps.getTrack(this.props.updatedVideo),
    urlVideoGoProBack: 'https://sd1.ipsgeoprocesing.ipsilum.com/MG/ffmpeg/exec_csv_from_video',
    dateStringGPSVideo: videoOps.getTimeGPS(this.props.updatedVideo),
    isLoadingDataVideo: false,
    datePicker: '',
    timePicker: '',
    isAutoLoadData: true,
    dataLoaded: false,
    disabledLoadData: false,
    videoURLForm: 'url',
    isShowInfoUploadVideo: false,
    isShowInfoLoadDataVideo: false
  };

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) {
      this.loadClientModules();
      this.setDefaultDate();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { changeVideoEditorContainerStateProperty } = this.props;
    const {
      coordinatesDataType,
      latLng0,
      track,
      clientModulesReady,
      datePicker,
      timePicker,
      dateStringGPSVideo
    } = this.state;
    const {
      coordinatesDataType: prevCoordinatesDataType,
      latLng0: prevLatLng0,
      track: prevTrack,
      datePicker: prevDatePicker,
      timePicker: prevTimePicker,
      dateStringGPSVideo: prevDateStringGPSVideo
    } = prevState;
    if (clientModulesReady) {
      if (!isEqual(track, prevTrack) || !isEqual(latLng0, prevLatLng0)) {
        changeVideoEditorContainerStateProperty('isTrackUpdated', true);
      }

      if (!isEqual(coordinatesDataType, prevCoordinatesDataType)) {
        this.handleCoordinatesDataTypeChange();
      }

      if (!isEqual(dateStringGPSVideo, prevDateStringGPSVideo)) {
        this.closeLoadDataVideo();
      }

      if (!isEqual(datePicker, prevDatePicker) || !isEqual(timePicker, prevTimePicker)) {
        this.handleNewTimeRecording(datePicker, timePicker);
      }
    }
  }

  changeCoordinatesDataType = event => this.setState({ coordinatesDataType: event.target.value });

  changeDisabledLoadData = value => this.setState({ disabledLoadData: value });

  handleButtonVideoURLForm = value => {
    this.setState({ videoURLForm: value });
  };

  handleClickOnNext = () => {};

  setDefaultDate = () => {
    const { dateStringGPSVideo } = this.state;
    this.setState({
      timePicker: dateStringGPSVideo.substring(
        dateStringGPSVideo.lastIndexOf('T') + 1,
        dateStringGPSVideo.lastIndexOf('Z')
      ),
      datePicker: dateStringGPSVideo.substring(0, dateStringGPSVideo.lastIndexOf('T'))
    });
  };

  changeEditionStep = () => {
    const { changeVideoEditorContainerStateProperty } = this.props;
    changeVideoEditorContainerStateProperty('editionStep', 1);
  };

  changeVideoEditorStateProperty = (property, newValue) => this.setState({ [property]: newValue });

  handleAddTag = tag => this.setState(prevState => ({ tags: [...prevState.tags, tag] }));

  handleConfirm = () => {
    this.setState({ showModal: false });
    this.changeEditionStep();
  };

  handleDeleteTag = i =>
    this.setState(prevState => ({ tags: filter(prevState.tags, (tag, index) => index !== i) }));

  handleCoordinatesDataTypeChange = () =>
    this.setState({
      areCoordinatesUndefined: true,
      controlPoints: {},
      featureArray: [],
      geometryFileName: '',
      latLng0: [],
      logFileName: '',
      showModal: false,
      track: {}
    });

  handleSubmit = async form => {
    const {
      updatedVideo,
      isTrackUpdated,
      changeVideoEditorContainerStateProperty,
      updateVideo
    } = this.props;
    const {
      areCoordinatesUndefined,
      controlPoints,
      coordinatesDataType,
      featureArray,
      geometryFileName,
      latLng0,
      logFileName,
      tags,
      track,
      dateStringGPSVideo,
      videoURLForm
    } = this.state;

    const existingVideo = !isEmpty(videoOps.getId(updatedVideo));
    const submitURL =
      videoURLForm === 'upload' ? videoOps.getURL(updatedVideo) : form.url.value.trim();
    const newVideo = {
      name: form.name.value.trim(),
      description: form.description.value.trim(),
      type: form.type.value.trim(),
      url: submitURL,
      coordinatesDataType,
      tags,
      timeGPSRecording: dateStringGPSVideo
    };

    if (coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.POINT) {
      assign(newVideo, {
        noCoordinates: true,
        latLng0
      });
    }

    if (coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.LINE) {
      assign(newVideo, {
        noCoordinates: true,
        controlPoints,
        latLng0,
        track
      });
    }

    if (coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.KML) {
      assign(newVideo, {
        noCoordinates: true,
        controlPoints,
        geometryFileName,
        latLng0,
        track
      });
    }

    if (coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.CSV) {
      assign(newVideo, {
        noCoordinates: areCoordinatesUndefined,
        controlPoints,
        logFileName,
        latLng0,
        track
      });
    }

    if (coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.CSV_GO_PRO) {
      assign(newVideo, {
        noCoordinates: false,
        controlPoints,
        logFileName,
        latLng0,
        track
      });
    }

    if (existingVideo) newVideo._id = existingVideo;

    try {
      if (isEmpty(latLng0)) {
        throw new Error('The initial point has not been defined');
      } else if (coordinatesDataType !== VIDEO_COORDINATE_DATA_TYPES.POINT) {
        FeatureLineString.validate(track);
      }

      updateVideo(newVideo);
      changeVideoEditorContainerStateProperty('featureArray', featureArray);

      if (isTrackUpdated) {
        this.setState({ showModal: true });
      } else {
        this.changeEditionStep();
      }
    } catch (error) {
      console.error(error);
      Bert.alert('The coordinates have not been defined right', 'danger');
    }
    return true;
  };

  loadCSVFile = async event => {
    // TODO: limpiar la variable file
    const file = event.target.files[0];
    try {
      const { changeVideoEditorContainerStateProperty } = this.props;
      const {
        newFeatureArray,
        newTrack,
        newControlPoints,
        areCoordinatesUndefined
      } = await createTrackFromCSV(file);

      const newLatLng0 = turf.getCoords(newTrack)[0];
      const newLocation = turf.point(newLatLng0, { zoom: 15 });

      changeVideoEditorContainerStateProperty('ignoreCSVTimes', false);

      this.setState({
        areCoordinatesUndefined,
        controlPoints: newControlPoints,
        featureArray: newFeatureArray,
        logFileName: file.name.trim(),
        latLng0: newLatLng0,
        mapLocation: newLocation,
        track: newTrack
      });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  loadCSVGoProFile = async (event, dateGPSRecording) => {
    // TODO: limpiar la variable file
    const file = event.target.files[0];
    try {
      const { changeVideoEditorContainerStateProperty } = this.props;
      const { newFeatureArray, newTrack, newControlPoints } = await createTrackFromGoProCSV(
        file,
        dateGPSRecording
      );

      const newLatLng0 = turf.getCoords(newTrack)[0];
      const newLocation = turf.point(newLatLng0, { zoom: 15 });

      changeVideoEditorContainerStateProperty('ignoreCSVTimes', false);

      this.setState({
        areCoordinatesUndefined: true,
        controlPoints: newControlPoints,
        featureArray: newFeatureArray,
        logFileName: file.name.trim(),
        latLng0: newLatLng0,
        mapLocation: newLocation,
        track: newTrack,
        isLoadingDataVideo: false
      });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  loadInputVideo = async event => {
    const { updatedVideo } = this.props;
    this.setState({ isLoadingImporFile: true, isShowInfoUploadVideo: true });

    const file = event.target.files[0];
    event.preventDefault();

    if (!file) {
      this.setState({ isLoadingImporFile: false });
      Bert.alert('Selecciona un archivo primero', 'danger');
      this.setState({
        importFileName: ''
      });
      return;
    }
    if (!file.type.includes('video')) {
      this.setState({ isLoadingImporFile: false });
      Bert.alert('Selecciona un archivo en formato video.', 'danger');
      this.setState({
        importFileName: ''
      });
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('disc', 'data3');

    try {
      const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });

      this.setState({
        importFileName: file.name
      });
      const respuesta = await response.json();
      updatedVideo.url = respuesta.data.link;
      this.callBackGoProVideo(respuesta.data.link);
    } catch (error) {
      console.error('Error:', error);
      this.setState({ isLoading: false });
    }
  };

  loadKMLFile = async event => {
    // TODO: limpiar la variable file
    const file = event.target.files[0];
    try {
      const { newFeatureArray, newTrack, newControlPoints } = await createTrackFromKML(file);

      const newLatLng0 = turf.getCoords(newTrack)[0];
      const newLocation = turf.point(newLatLng0, { zoom: 15 });

      this.setState({
        areCoordinatesUndefined: true,
        controlPoints: newControlPoints,
        featureArray: newFeatureArray,
        geometryFileName: file.name.trim(),
        latLng0: newLatLng0,
        mapLocation: newLocation,
        track: newTrack
      });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  toggleButtonSwitch = (thisButton = '') => {
    this.setState(prevState => {
      const newButtonStates = cloneDeep(prevState.buttonStates);
      forEach(prevState.buttonStates, (myButton, key) => {
        if (thisButton !== key && myButton) newButtonStates[key] = false;
      });
      if (thisButton) newButtonStates[thisButton] = !prevState.buttonStates[thisButton];
      return { buttonStates: newButtonStates };
    });
  };

  handleNewTimeRecording = (date, time) => {
    const dateGPSRecording = `${date}T${time}Z`;
    this.setState({ dateStringGPSVideo: dateGPSRecording });
  };

  handleDatePicker = (picker, value) => {
    if (picker === 'date') this.setState({ datePicker: value });
    if (picker === 'time') this.setState({ timePicker: value });
  };

  closeLoadDataVideo = () => {
    this.setState({ isLoadingDataVideo: false });
  };

  setIsAutoLoadData = isAuto => {
    this.setState({ isAutoLoadData: isAuto });
  };

  handleSourceVideo = source => {
    if (source === VIDEO_TYPES.VIDEOWITHINFO) this.setState({ isAutoLoadData: true });
    else if (source === VIDEO_TYPES.VIDEOWITHOUTINFO) this.setState({ isAutoLoadData: false });
  };

  callBackGoProVideo = async urlUser => {
    const { urlVideoGoProBack } = this.state;
    try {
      if (urlUser !== '') {
        const isValid = YOUTUBE_URL_REGEX.test(urlUser) || URL_REGEX.test(urlUser);
        if (isValid) {
          this.setState({
            isLoadingDataVideo: true,
            isShowInfoLoadDataVideo: true,
            isShowInfoUploadVideo: false
          });
          const response = await fetch(urlVideoGoProBack, {
            method: 'POST',
            body: JSON.stringify({
              user: '',
              pathVideo: urlUser,
              time: ''
            }),
            headers: { 'Content-Type': 'application/json' }
          });
          const responseJson = await response.json();
          if (!isEmpty(responseJson)) {
            const dateGPSRecording = responseJson.date;
            const urlCSV = responseJson.url;
            const data = responseJson.csvData;
            if (!isEmpty(data)) {
              const nameFile = urlCSV.substring(urlCSV.lastIndexOf('/') + 1, urlCSV.length);
              const newFile = new File([data], nameFile, { type: 'text/csv' });
              this.loadCSVGoProFile({ target: { files: [newFile] } }, dateGPSRecording);
              this.setState({
                coordinatesDataType: VIDEO_COORDINATE_DATA_TYPES.CSV_GO_PRO
              });
            }
            if (!isEmpty(dateGPSRecording)) {
              this.setState({
                dateStringGPSVideo: dateGPSRecording,
                timePicker: dateGPSRecording.substring(
                  dateGPSRecording.lastIndexOf('T') + 1,
                  dateGPSRecording.lastIndexOf('.') + 4
                ),
                datePicker: dateGPSRecording.substring(0, dateGPSRecording.lastIndexOf('T'))
              });
            }
            this.setState({
              isLoadingDataVideo: false,
              isLoadingImporFile: false,
              disabledLoadData: true,
              dataLoaded: true,
              isShowInfoLoadDataVideo: false
            });
            Bert.alert('Data downloaded successfully', 'success');
          } else {
            this.setState({ isLoadingDataVideo: false, dataLoaded: true, isAutoLoadData: false });
            Bert.alert('No data found', 'warning');
          }
        }
      } else {
        Bert.alert('Enter a url or upload a video', 'warning');
      }
    } catch (e) {
      this.setState({ isLoadingDataVideo: false, coordinatesDataType: '', dataLoaded: true });
      Bert.alert('An error occurred while downloading data', 'danger');
    }
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      ({ createTrackFromKML, createTrackFromCSV, createTrackFromGoProCSV } = await import(
        '../../../modules/geomotionvideo-operations'
      ));
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const { updatedVideo, deployEnv, suggestions, isFree } = this.props;
    const { buttonStates, showModal, tags } = this.state;

    const validationProps = {
      rules: {
        name: {
          required: true
        },
        description: {
          required: false
        },
        url: {
          required: true,
          format: isFree ? YOUTUBE_URL_REGEX : URL_REGEX
        },
        'created[0][value][time]': { step: false }
      },
      messages: {
        name: {
          required: 'Need a name in here, Seuss.'
        },
        url: {
          required: 'This needs a video url, please.',
          format: 'Not a valid url'
        }
      },
      submitHandler: form => {
        this.handleSubmit(form);
      }
    };

    const mapProps = {
      defineLineActive: buttonStates.defineLineActive,
      definePointActive: buttonStates.definePointActive,
      deployEnv,
      changeVideoEditorStateProperty: this.changeVideoEditorStateProperty,
      toggleButtonSwitch: this.toggleButtonSwitch,
      updatedVideo,
      ...this.state
    };

    return (
      <>
        <ConfirmationModal
          message="Save new track?"
          showModal={showModal}
          onCloseFunction={() => this.setState({ showModal: false })}
          onConfirmFunction={this.handleConfirm}
        />
        <Row>
          <Col xs={12} sm={4}>
            <Validation {...validationProps}>
              <Form id="videoEditorForm" onSubmit={event => event.preventDefault()}>
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    defaultValue={videoOps.getName(updatedVideo)}
                    onFocus={() => this.toggleButtonSwitch()}
                    placeholder="Oh, The Places You'll Go!"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    defaultValue={videoOps.getDescription(updatedVideo)}
                    onFocus={() => this.toggleButtonSwitch()}
                    placeholder="Congratulations! Today is your day. You're off to Great Places! You're
                off and away!"
                  />
                </Form.Group>
                <VideoFields
                  buttonStates={buttonStates}
                  updatedVideo={updatedVideo}
                  changeCoordinatesDataType={this.changeCoordinatesDataType}
                  changeVideoEditorStateProperty={this.changeVideoEditorStateProperty}
                  loadCSVFile={this.loadCSVFile}
                  loadCSVGoProFile={this.loadCSVGoProFile}
                  loadInputVideo={this.loadInputVideo}
                  loadKMLFile={this.loadKMLFile}
                  toggleButtonSwitch={this.toggleButtonSwitch}
                  callBackGoProVideo={this.callBackGoProVideo}
                  handleDatePicker={this.handleDatePicker}
                  setIsAutoLoadData={this.setIsAutoLoadData}
                  changeDisabledLoadData={this.changeDisabledLoadData}
                  handleButtonVideoURLForm={this.handleButtonVideoURLForm}
                  handleSourceVideo={this.handleSourceVideo}
                  {...this.state}
                />
                <Form.Group>
                  <Form.Label>Tags</Form.Label>
                  <TagInput
                    tags={tags}
                    suggestions={suggestions}
                    handleAddition={this.handleAddTag}
                    handleDelete={this.handleDeleteTag}
                    onFocus={this.toggleButtonSwitch}
                  />
                </Form.Group>
              </Form>
            </Validation>
          </Col>
          <Col xs={12} sm={8}>
            <MapContainerVideoEditor {...mapProps} />
          </Col>
        </Row>
      </>
    );
  }
}

VideoEditor.defaultProps = {
  isFree: false
};

VideoEditor.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  featureArray: PropTypes.array.isRequired,
  ignoreCSVTimes: PropTypes.bool.isRequired,
  isTrackUpdated: PropTypes.bool.isRequired,
  isFree: PropTypes.bool,
  mapLocation: PropTypes.object.isRequired,
  suggestions: PropTypes.array.isRequired,
  updatedVideo: PropTypes.object.isRequired,
  changeVideoEditorContainerStateProperty: PropTypes.func.isRequired,
  updateVideo: PropTypes.func.isRequired
};

export default VideoEditor;
